import { changeStepSelectRetention as changeStepSelectRetentionDiagram, selectStepFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';

export type StepSelectRetentionProps = {
    mode?: string;
}

export const changeStepSelectRetention = ({
    mode,
}: StepSelectRetentionProps) => {
    changeStepSelectRetentionDiagram({ mode });
    selectStepFilterGridData('');
};
